import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const EmployeeRootPage = React.lazy(() => import('modules/performance_v2/pages/EmployeeRootPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.performance.path,
      element: <EmployeeRootPage />,
    },
  ]
}

export default employeesRoutes
